const BaseView = require('components-framework/view/base.view');
const trackingUtils = require('od-modules/utils/tracking.utils');

module.exports = BaseView.extend({
    selectors: {
        tooltip: '.tooltip_container',
        moreInfo: '.more_info_container',
        iconArrow: '.icon_arrow',
    },
    events: {
        'tap .know_more': 'toggleTooltip',
        'tap .know_more_close': 'toggleTooltip',
        'tap .more_info_toggle': 'toggleMoreInfo',
    },
    initialize(options) {
        BaseView.prototype.initialize.call(this, options);
        this.listenTo(this.model, 'change:membershipDiscount', this.render);
        this.render();
    },
    render() {
        const {autoApplyDiscount, fee} = this.model.get('membershipDiscount');
        if (autoApplyDiscount && !Odigeo.Membership.isPrimeBannerFareMobile) {
            this.$el.html(this.templates.main({
                keys: {
                    ...this.keys,
                    title: Odigeo.Utils.replaceCmsKeyArgs(this.keys.title, parseFloat(fee).toFixed(2)),
                },
            }));
            trackingUtils.trackEventWithCategory('flights_pay_page', 'prime_mem_disc_banner', 'shown_mem_disc_pag:pay');
            Odigeo.trigger(`${this.id}:isAutoApplyDiscount`, autoApplyDiscount);
        } else {
            this.$el.empty();
        }
    },
    toggleTooltip(event) {
        const $element = $(event.target);
        trackingUtils.trackEventWithCategory('flights_pay_page', 'prime_mem_disc_banner', $element.data('label'));
        this.$el.find(this.selectors.tooltip).toggleClass('open');
    },
    toggleMoreInfo() {
        const $moreInfo = this.$el.find(this.selectors.moreInfo);
        const $iconArrow = this.$el.find(this.selectors.iconArrow);

        $moreInfo.toggleClass('odf-hidden');
        $iconArrow.toggleClass('odf-icon-arrow-up');

        const action = $moreInfo.hasClass('odf-hidden') ? '_close' : '';

        trackingUtils.trackEventWithCategory(
            `flights_pay_page`,
            `prime_mem_disc_banner`,
            `know_more_mem_disc${action}_pag:pay`
        );
    },
});
